/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCloudOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M.6.468a.75.75 0 011.06.003L5.625 4.46a.745.745 0 01.023.024L20.24 19.16a.817.817 0 01.023.023l3.269 3.288a.75.75 0 01-1.064 1.058l-2.959-2.976c-.481.13-.979.196-1.479.197H9.087a8.672 8.672 0 01-5.382-1.769 8.752 8.752 0 01-3.161-4.727 8.794 8.794 0 01.401-5.68 8.742 8.742 0 012.97-3.707L.596 1.529A.75.75 0 01.6.469zm4.39 5.48a7.239 7.239 0 00-2.664 3.211 7.294 7.294 0 00-.332 4.711 7.252 7.252 0 002.619 3.917 7.173 7.173 0 004.456 1.463h8.959c.06 0 .122-.002.182-.004L4.99 5.948zM8.331 4a.75.75 0 01.75-.75c2.391 0 4.186.674 5.582 1.867 1.258 1.076 2.14 2.531 2.866 4.144 2.65.116 4.39 1.17 5.309 2.734.947 1.612.92 3.599.376 5.24a.75.75 0 11-1.424-.47c.45-1.359.423-2.872-.245-4.01-.642-1.092-1.973-2.005-4.511-2.005a.75.75 0 01-.69-.456c-.729-1.71-1.543-3.085-2.656-4.036-1.09-.932-2.525-1.508-4.607-1.508a.75.75 0 01-.75-.75z'
        />
      </g>
      <defs>
        <clipPath id='cloud-off_svg__clip0_126_10407'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCloudOff;
